/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * wedofi
 * A RESTful API. 🔒 Protected endpoints require authentication via secure HTTP-only cookies. Authentication is handled automatically by Better Auth after login.
 * OpenAPI spec version: 1.0.47
 */

export type ReferralListItemStatus = typeof ReferralListItemStatus[keyof typeof ReferralListItemStatus];


export const ReferralListItemStatus = {
  PENDING: 'PENDING',
  QUALIFIED: 'QUALIFIED',
} as const;
